import { gql } from '@apollo/client'

const PRIORITY_TASK_MENU_ALLOCATION_COUNTS_QUERY = gql`
  query priorityTaskMenuAllocationCountsQuery($priorityTaskId: ID!) {
    priorityTaskMenuAllocationCounts(priorityTaskId: $priorityTaskId) {
      availableMenusCount
      allocatedMenusCount
      doneMenusCount
      availableDishCount
      allocatedDishCount
      doneDishCount
    }
  }
`

export default PRIORITY_TASK_MENU_ALLOCATION_COUNTS_QUERY
